/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ValidatePasswordResetToken model module.
 * @module model/ValidatePasswordResetToken
 * @version v1
 */
export class ValidatePasswordResetToken {
  /**
   * Constructs a new <code>ValidatePasswordResetToken</code>.
   * @alias module:model/ValidatePasswordResetToken
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ValidatePasswordResetToken</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ValidatePasswordResetToken} obj Optional instance to populate.
   * @return {module:model/ValidatePasswordResetToken} The populated <code>ValidatePasswordResetToken</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ValidatePasswordResetToken();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('login'))
        obj.login = ApiClient.convertToType(data['login'], 'String');
      if (data.hasOwnProperty('token_id'))
        obj.token_id = ApiClient.convertToType(data['token_id'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
ValidatePasswordResetToken.prototype.status = undefined;

/**
 * @member {String} login
 */
ValidatePasswordResetToken.prototype.login = undefined;

/**
 * @member {String} token_id
 */
ValidatePasswordResetToken.prototype.token_id = undefined;

/**
 * @member {String} message
 */
ValidatePasswordResetToken.prototype.message = undefined;

